import React, { FC, PropsWithChildren, createContext, useContext } from 'react';

import { useTokens } from '@services/api/vaults/tokens.api';

import { tokens } from '@config/vaults/tokens';

import { TokensDto } from '@dto/vaults/tokens.dto';

interface VaultTokensContextType {
  tokens: TokensDto | undefined;
  isLoading: boolean;
}

export const VaultTokensContext = createContext<VaultTokensContextType>({
  tokens: undefined,
  isLoading: false,
});

export const useVaultTokens = (): VaultTokensContextType =>
  useContext(VaultTokensContext);

const VaultTokensContextProvider: FC<PropsWithChildren> = ({ children }) => {
  // const { data, isLoading } = useTokens();
  //
  // console.log(JSON.stringify(data));

  return (
    <VaultTokensContext.Provider
      value={{
        tokens,
        isLoading: false,
      }}
    >
      {children}
    </VaultTokensContext.Provider>
  );
};

export default VaultTokensContextProvider;
